<template>
<span ref="span">
    <slot></slot>
</span>
</template>
<script>
import { mapBus } from '../utils/map-bus'

export default {
    props: {
        id: {
            type: String,
            _descr: 'Id of location to highlight on element mouseover',
        },
    },
    mounted () {
        this.$refs.span.addEventListener('mouseover', () => {
            mapBus.$emit('highlight', this.id)
        })
        this.$refs.span.addEventListener('mouseleave', () => {
            mapBus.$emit('highlight', null)
        })
    },
}
</script>
